import { Label } from "./ui/label";

const OptionGroup = ({ label, options, value, onChange, testPrefix }) => {
  return (
    <div>
      <Label className="text-sm font-medium text-slate-700 mb-3 block">{label}</Label>
      <div className="flex flex-wrap gap-2 sm:gap-3">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`px-4 sm:px-5 py-2.5 sm:py-3 rounded-xl border-2 font-medium text-sm sm:text-base transition-all ${
              value === option
                ? "border-amber-500 bg-amber-50 text-slate-900"
                : "border-slate-200 hover:border-slate-300 bg-white text-slate-700"
            }`}
            data-testid={`${testPrefix}-${option.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OptionGroup;
